import AboutHero from "@/components/about/AboutHero";
import AboutImageBreak from "@/components/about/AboutImageBreak";
import AboutPhilosophy from "@/components/about/AboutPhilosophy";
import AboutPillars from "@/components/about/AboutPillars";
import AboutFounder from "@/components/about/AboutFounder";
import AboutClosingCTA from "@/components/about/AboutClosingCTA";

export default function About() {
  return (
    <main className="bg-ivory text-ink">
      <AboutHero />
      <AboutImageBreak />
      <AboutPhilosophy />
      <AboutPillars />
      <AboutFounder />
      <AboutClosingCTA />
    </main>
  );
}
